<form [formGroup]="form" class="form card-body-modal">
  <h2 class="mb14">Rechthebbende uitnodigen</h2>
  <div class="spacer-small"></div>
  <div [ngClass]="{ 'input-error': submitted && f.email.errors }">
    <label class="form-label" for="email">e-mailadres rechthebbende</label>
    <input formControlName="email" id="email" class="extended" type="email">
    <div *ngIf="submitted && f.email.errors">
      <div *ngIf="f.email.errors.required">dit veld is verplicht.</div>
      <div *ngIf="!f.email.errors.required && f.email.errors.pattern">dit is geen geldig e-mailadres.</div>
    </div>
    <div *ngIf="error">
      {{error}}
    </div>
  </div>
  <div class="spacer"></div>
  <div class="flex space-between">
    <button (click)="cancel()" type="button" class="btn btn-left arrow-left">annuleer</button>
    <button (click)="invite()" *ngIf="!isLoading" class="btn accent inverted plus">uitnodigen</button>
  </div>
</form>
